export const API_CONFIG = {
  BASE_URL: "https://tg-mini-app-api.hi-sender.workers.dev",
  ENDPOINTS: {
    OFFERS: "/api/offers",
    CACHE_FLUSH: "/api/cache/flush"
  }
};